import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IHref, ILink, ILinkProperty } from '@src/slide/domain/ui-model/element-modeles/property/link/link.interface';

export class LinkProperty implements ILinkProperty {
    private elementModelRef: IElementBaseModel;
    public constructor(elementModel: IElementBaseModel) {
        this.elementModelRef = elementModel;
    }

    public getLink(): ILink | undefined {
        return this.elementModelRef.props.link;
    }

    public updateLink(link: ILink): void {
        const removeVal = this.getRemoveValByVal(link?.href);
        this.elementModelRef.updateAndRemoveProps(
            { link: { href: link?.href } },
            removeVal ? { link: { href: removeVal } } : null,
        );
    }

    public removeLink(): void {
        this.elementModelRef.removeProps({ link: null });
    }

    private getRemoveValByVal(val: IHref | undefined) {
        let removeVal: {[x: string]: null} | null = {};
        if (val?.url) {
            removeVal.slideJump = null;
        } else if (val?.slideJump) {
            removeVal.url = null;
        } else if (val?.mail) {
            removeVal.slideJump = null;
        } else {
            removeVal = null;
        }
        return removeVal;
    }
}
